import {
  Message,
  SenderOrRecipientType,
  MessageType,
  TextPayloadInterface,
  ButtonsPayloadInterface,
  TakeoverEventPayload,
  ActionTakenPayload,
  StoreVars,
  TakeoverEventType
} from '../swivl-lib'

export function ConvertMessageToGPTLine(message: Message): string {
  let type
  if (message.from && message.from.type) {
    if (message.from.type === SenderOrRecipientType.BotUser) {
      type = 'User'
    } else if (message.from.type === SenderOrRecipientType.Bot) {
      type = 'Bot'
    } else if (message.from.type === SenderOrRecipientType.Agent) {
      type = 'Agent'
    }
  }

  if (!type) {
    return ''
  }

  if (message.type === MessageType.Text) {
    const payload: TextPayloadInterface = message.payload as any
    return type + ': ' + payload.text + '\n'
  } else if (message.type === MessageType.Buttons) {
    const payload: ButtonsPayloadInterface = message.payload as any

    if (message.from && message.from.type && message.actionTaken) {
      const action = payload.actions.find(a =>
        message && message.actionTaken ? a.id === message.actionTaken.target : false
      )
      if (action) {
        return type + ': ' + action.text + '\n'
      }
    }
  } else if (message.type === MessageType.TakeoverEvent) {
    const payload: TakeoverEventPayload = message.payload as any
    if (payload.type === TakeoverEventType.TAKEOVER_STARTED) {
      return 'Bot: Chat has been transferred to back to agent ' + payload.name + ' bot\n'
    } else {
      return 'Bot: Chat has been transferred to back to the ' + payload.name + ' bot\n'
    }
  } else if (message.type === MessageType.ActionTaken) {
    const payload: ActionTakenPayload = message.payload as ActionTakenPayload
    if (payload && payload.actionTaken && payload.actionTaken.data) {
      const data: any = payload.actionTaken.data
      if (data[StoreVars.StoreName]) {
        return 'User: I select store ' + data[StoreVars.StoreName] + '\n'
      }
      if (data['name']) {
        return 'User: I select unit ' + data['name'] + '\n'
      }
    }
  }

  return ''
}
